
import { defineComponent } from "vue"
import CardRaritiesForm from "@/components/card_rarities/Form.vue"

export default defineComponent({
  components: {
    CardRaritiesForm
  }
})
